<script>
import Auth from "../../layouts/auth";
import { consumeSsoState } from "@/helpers/authservice/sso";

/**
 * Callback redirect SSO Azure (VUE_APP_REDIRECT_URI)
 */
export default {
  page: {
    title: "Signing in",
  },
  components: {
    Auth,
  },
  created() {
    const { code, state, error, error_description } = this.$route.query;
    const nonce = consumeSsoState(state);

    if (error || !code || !nonce) {
      this.$store.dispatch(
        "notification/error",
        error_description || "Login SSO gagal, silakan coba lagi"
      );
      this.$router.replace({ name: "login" });
      return;
    }

    this.$store.dispatch("notification/clear");
    this.$store.dispatch("authfack/loginSso", { code, nonce });
  },
};
</script>

<template>
  <Auth>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card">
          <div class="card-body p-4 text-center">
            <b-spinner variant="primary" class="mb-3"></b-spinner>
            <p class="text-muted mb-0">Signing in with Microsoft...</p>
          </div>
        </div>
      </div>
    </div>
  </Auth>
</template>
